import PropTypes from "prop-types";
import React from "react";
import { Modal } from "react-bootstrap";

const AlertDialogModal = (props) => {
  const {
    modalShow,
    modalClass,
    handleYesDeleteAlert,
    handleCancelDeleteAlert,
    messageText,
    headingText,
    loader,
    handleDeleteUpdate
  } = props;
  const renderModalFooterButtons = () => {
    if (props?.default) {
      return (
        <button
          className="btn cus-seconday-bg-btn btn btn-primary okBtn"
          onClick={handleCancelDeleteAlert}
        >
          Ok
        </button>
      );
    }

    if (props?.showUpdateBtn) {
      return (
        <>
          <button
            className="btn cus-seconday-bg-btn btn btn-primary cancelBtn"
            onClick={(event) => handleDeleteUpdate(event, "delete")}
            disabled={loader}
          >
            Delete
          </button>
          {!props.selectedRecords && (
            <button
              className="btn cus-seconday-bg-btn btn btn-primary marginLeft5 yesBtn"
              onClick={(event) => handleDeleteUpdate(event, "update")}
              disabled={loader}
            >
              Update
            </button>
          )}
        </>
      );
    }

    return (
      <>
        <button
          className="btn cus-seconday-bg-btn btn btn-primary cancelBtn"
          onClick={handleCancelDeleteAlert}
          disabled={loader}
        >
          Cancel
        </button>
        <button
          className="btn cus-seconday-bg-btn btn btn-primary marginLeft5 yesBtn"
          onClick={handleYesDeleteAlert}
          disabled={loader}
        >
          Yes
        </button>
      </>
    );
  };
  return (
    <Modal
      show={modalShow || false}
      size="md"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={handleCancelDeleteAlert}
      className={modalClass || ""}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {headingText ? headingText : "DELETE"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="messageWrapper">
          {messageText ? (
            <>{messageText}</>
          ) : (
            <>Are you sure, you want to delete this record?</>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {renderModalFooterButtons()}
      </Modal.Footer>
    </Modal>
  );
};

AlertDialogModal.propTypes = {
  modalShow: PropTypes.bool,
  modalClass: PropTypes.string,
  handleYesDeleteAlert: PropTypes.func,
  handleCancelDeleteAlert: PropTypes.func,
  messageText: PropTypes.string,
  headingText: PropTypes.string,
  loader: PropTypes.bool,
  handleDeleteUpdate: PropTypes.func,
  default: PropTypes.bool,
  showUpdateBtn: PropTypes.bool,
  selectedRecords: PropTypes.bool
}

export default AlertDialogModal;
